/* ZK Mystery Pack - behaviour. Initialises every .zk-mp root once; no globals leaked except the IIFE guard. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRoot(root) {
    if (!root || root.getAttribute('data-zk-init')) return;
    root.setAttribute('data-zk-init', '1');
    root.classList.add('is-js');

    function $(sel, ctx) { return (ctx || root).querySelector(sel); }
    function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

    /* reveal on scroll */
    var revealEls = $$('[data-reveal]');
    if ('IntersectionObserver' in window) {
      var rio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); } });
      }, { threshold: 0.1 });
      revealEls.forEach(function (el) { rio.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
    }

    /* 3D tilt + holo sheen */
    var stage = $('[data-stage]');
    if (stage && !reduce && window.matchMedia('(hover: hover)').matches) {
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width;
        var y = (e.clientY - r.top) / r.height;
        stage.style.setProperty('--rx', ((0.5 - y) * 16).toFixed(2) + 'deg');
        stage.style.setProperty('--ry', ((x - 0.5) * 20).toFixed(2) + 'deg');
        stage.style.setProperty('--gx', (x * 100).toFixed(1) + '%');
        stage.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
      });
      stage.addEventListener('pointerleave', function () {
        stage.style.setProperty('--rx', '0deg');
        stage.style.setProperty('--ry', '0deg');
      });
    }

    /* pack / variant selection */
    var radios = $$('.zk-mp__radio');
    var priceNow = $('[data-price-now]');
    var priceWas = $('[data-price-was]');
    var chip = $('[data-save-chip]');
    var chipMoney = $('[data-save-money]');
    var sticker = $('[data-sticker]');
    var badgeNum = $('[data-badge-num]');
    var slides = $$('[data-slide]');
    var barName = $('[data-bar-name]');
    var barPrice = $('[data-bar-price]');
    var atcs = $$('[data-atc]');
    var currentId = root.getAttribute('data-variant');
    var isMain = root.getAttribute('data-main') === 'true';
    var labelAdd = root.getAttribute('data-label-add') || 'Add to cart';
    var labelSold = root.getAttribute('data-label-sold') || 'Sold out';

    function bump(el) {
      if (!el || reduce) return;
      el.classList.remove('zk-mp__bump');
      void el.offsetWidth;
      el.classList.add('zk-mp__bump');
    }
    function countUp(el, to) {
      if (!el) return;
      var from = parseInt(el.textContent, 10) || 0;
      if (reduce || from === to) { el.textContent = to; return; }
      var t0 = null, dur = 600;
      function tick(ts) {
        if (t0 === null) t0 = ts;
        var k = Math.min((ts - t0) / dur, 1);
        el.textContent = Math.round(from + (to - from) * (1 - Math.pow(1 - k, 3)));
        if (k < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    function setLabels(txt) {
      $$('[data-atc-label]').forEach(function (el) { el.textContent = txt; });
    }
    function applyPack(r) {
      currentId = r.getAttribute('data-variant-id');
      var d = function (k) { return r.getAttribute('data-' + k) || ''; };
      var pct = parseInt(d('save-pct'), 10) || 0;
      if (priceNow) { priceNow.textContent = d('price'); bump(priceNow); }
      if (priceWas) { priceWas.textContent = d('compare'); priceWas.hidden = !pct; }
      if (chip) { chip.hidden = !pct; if (chipMoney) chipMoney.textContent = d('save-money'); }
      if (sticker) { sticker.hidden = !pct; }
      countUp(badgeNum, pct);
      if (barName) barName.textContent = d('title');
      if (barPrice) barPrice.textContent = d('price');
      var imgId = d('image-id');
      var hit = slides.some(function (sl) { return sl.getAttribute('data-image-id') === imgId; });
      if (hit) slides.forEach(function (sl) { sl.classList.toggle('is-active', sl.getAttribute('data-image-id') === imgId); });
      var ok = d('available') === 'true';
      atcs.forEach(function (b) { b.disabled = !ok; });
      setLabels(ok ? labelAdd : labelSold);
      if (isMain && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', currentId);
          history.replaceState(null, '', u.toString());
        } catch (err) {}
      }
    }
    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) applyPack(r); });
    });

    /* quantity */
    var qty = $('[data-qty]');
    function clampQty() {
      var v = parseInt(qty.value, 10);
      if (!v || v < 1) v = 1;
      if (v > 20) v = 20;
      qty.value = v;
    }
    if (qty) {
      var qm = $('[data-qty-minus]'), qp = $('[data-qty-plus]');
      if (qm) qm.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) - 1; clampQty(); });
      if (qp) qp.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; clampQty(); });
      qty.addEventListener('change', clampQty);
    }

    /* confetti */
    function burst(host) {
      if (reduce || !host) return;
      var cs = getComputedStyle(root);
      var colors = [cs.getPropertyValue('--mp-acc').trim() || '#f5b800', cs.getPropertyValue('--mp-hot').trim() || '#d22b2b', '#ffffff', '#ffe17a'];
      for (var i = 0; i < 22; i++) {
        var s = document.createElement('span');
        s.className = 'zk-mp__conf';
        var a = Math.random() * Math.PI * 2;
        var dist = 70 + Math.random() * 90;
        s.style.setProperty('--x', (Math.cos(a) * dist).toFixed(0) + 'px');
        s.style.setProperty('--y', (Math.sin(a) * dist - 30).toFixed(0) + 'px');
        s.style.setProperty('--rot', (Math.random() * 720 - 360).toFixed(0) + 'deg');
        s.style.setProperty('--c', colors[i % colors.length]);
        host.appendChild(s);
        (function (n) { setTimeout(function () { if (n.parentNode) n.parentNode.removeChild(n); }, 1000); })(s);
      }
    }

    /* add to cart (reuses the theme's own cart notification / drawer when present) */
    var busy = false;
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-atc]');
      if (!btn || btn.disabled || busy) return;
      busy = true;
      var host = btn.closest('[data-conf-host]');
      var q = qty ? (parseInt(qty.value, 10) || 1) : 1;
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      setLabels('Adding...');
      var fd = new FormData();
      fd.append('id', currentId);
      fd.append('quantity', q);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        fd.append('sections', cart.getSectionsToRender().map(function (x) { return x.id; }).join(','));
        fd.append('sections_url', window.location.pathname);
      }
      fetch(root.getAttribute('data-cart-add'), {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: fd
      }).then(function (r) { return r.json(); }).then(function (state) {
        if (state.status) { throw new Error(state.description || 'add failed'); }
        burst(host);
        if (cart && typeof cart.renderContents === 'function') {
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
          cart.renderContents(state);
          try {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zk-mystery-pack', productVariantId: currentId, cartData: state });
            }
          } catch (err) {}
          setLabels('Added!');
          setTimeout(function () { setLabels(labelAdd); busy = false; }, 1600);
        } else {
          window.location.href = root.getAttribute('data-cart-url');
        }
      }).catch(function () {
        setLabels('Try again');
        setTimeout(function () { setLabels(labelAdd); busy = false; }, 1800);
      });
    });

    /* sticky bar (mobile) */
    var bar = $('[data-bar]');
    var mainAtc = $('[data-main-atc]');
    if (bar && mainAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var en = es[0];
        bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(mainAtc);
    }

    /* mystery deck */
    var deck = $('[data-deck]');
    if (deck) {
      var labels = (deck.getAttribute('data-labels') || '').split('|').filter(function (x) { return x; });
      if (!labels.length) labels = ['Surprise'];
      var cards = $$('.zk-mp__card', deck);
      var counter = $('[data-count]');
      var shuffleBtn = $('[data-shuffle]');
      var pool = [];
      var mix = function (a) {
        for (var i = a.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var t = a[i]; a[i] = a[j]; a[j] = t;
        }
        return a;
      };
      var refill = function () { pool = mix(labels.slice()); };
      var updateCount = function () {
        var n = cards.filter(function (c) { return c.classList.contains('is-flipped'); }).length;
        if (counter) counter.textContent = (n === cards.length) ? 'All flipped. Your real pack is still a secret.' : n + ' of ' + cards.length + ' flipped';
      };
      cards.forEach(function (c) {
        c.addEventListener('click', function () {
          if (c.classList.contains('is-flipped')) {
            c.classList.remove('is-flipped');
            c.setAttribute('aria-pressed', 'false');
          } else {
            if (!pool.length) refill();
            c.querySelector('[data-card-label]').textContent = pool.pop();
            c.classList.add('is-flipped');
            c.setAttribute('aria-pressed', 'true');
          }
          updateCount();
        });
      });
      if (shuffleBtn) shuffleBtn.addEventListener('click', function () {
        cards.forEach(function (c, i) {
          setTimeout(function () { c.classList.remove('is-flipped'); c.setAttribute('aria-pressed', 'false'); }, reduce ? 0 : i * 90);
        });
        refill();
        setTimeout(updateCount, reduce ? 0 : cards.length * 90 + 50);
      });
      refill();
    }
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('.zk-mp')).forEach(initRoot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  /* theme editor: section re-rendered */
  document.addEventListener('shopify:section:load', initAll);
})();